/** Dropdown showcase data — from sf-react-app */
import React from 'react';
import {
  DateRangeIcon,
  DeleteIcon,
  EditIcon,
  ExpandAltIcon,
  LockIcon,
  SparkleIcon,
} from '../../../design-system/components/Icons';

const MULTISELECT_LOCATION_OPTIONS = [
  {
    value: '1',
    label: 'Alphega Farmacie - Tepes Voda',
  },
  {
    value: '2',
    label: 'Alphega Farmacie - Titulescu',
  },
  {
    value: '3',
    label: 'Chargebee Test Location',
  },
  {
    value: '4',
    label: 'GJ Location',
  },
  {
    value: '5',
    label: 'Greenlight Pharmacy - Bromley-by-Bow',
  },
  {
    value: '6',
    label: 'Greenlight Pharmacy - Cricklewood',
  },
  {
    value: '7',
    label: "Greenlight Pharmacy - Hodgett's Pharmacy",
  },
  {
    value: '8',
    label: 'Greenlight Pharmacy - Keencare Pharmacy Harrow',
  },
  {
    value: '9',
    label: 'Greenlight Pharmacy - Ritchie Street',
  },
  {
    value: '10',
    label: "Greenlight Pharmacy - Shepherd's Bush",
  },
  {
    value: '11',
    label: 'Test',
  },
  {
    value: '12',
    label: 'Test Client Connect 1',
  },
  {
    value: '13',
    label: 'Test Client Connect 2',
  },
  {
    value: '14',
    label: 'Test Site',
  },
  {
    value: '15',
    label: 'Test Time',
  },
];

const MULTISELECT_FILTER_GROUPS = [
  {
    label: 'Type',
    options: [
      { value: 'kpi', label: 'KPI' },
      { value: 'chart', label: 'Chart' },
      { value: 'table', label: 'Table' },
      { value: 'summary', label: 'Summary' },
    ],
  },
  {
    label: 'Status',
    options: [
      { value: 'added-already', label: 'Added Already' },
      { value: 'not-added', label: 'Not Added' },
      { value: 'favorites', label: 'Favorites' },
      { value: 'mandatory-only', label: 'Mandatory Only' },
    ],
  },
  {
    label: 'Data Source',
    options: [
      { value: 'sales', label: 'Sales' },
      { value: 'users', label: 'Users' },
      { value: 'operations', label: 'Operations' },
      { value: 'revenue', label: 'Revenue' },
    ],
  },
];

const CURRENCY_CODE_OPTIONS = [
  { value: 'GBP', label: 'GBP' },
  { value: 'USD', label: 'USD' },
  { value: 'EUR', label: 'EUR' },
];

const PHONE_AFFIX_SELECT_OPTIONS = [
  { value: 'IN', label: 'IN', subtitle: '+91', avatar: <span aria-hidden>🇮🇳</span> },
  { value: 'US', label: 'US', subtitle: '+1', avatar: <span aria-hidden>🇺🇸</span> },
  { value: 'GB', label: 'GB', subtitle: '+44', avatar: <span aria-hidden>🇬🇧</span> },
];

const USER_PICKER_OPTIONS = [
  {
    value: 'emma',
    label: 'Emma Thompson',
    subtitle: 'Manager',
    avatar: <span aria-hidden>ET</span>,
  },
  {
    value: 'sophie',
    label: 'Sophie Anderson',
    subtitle: 'Lead',
    avatar: <span aria-hidden>SA</span>,
  },
  {
    value: 'michael',
    label: 'Michael Brown',
    subtitle: 'Supervisor',
    avatar: <span aria-hidden>MB</span>,
  },
  {
    value: 'james',
    label: 'James Wilson',
    subtitle: 'Supervisor',
    avatar: <span aria-hidden>JW</span>,
  },
];

const LOCATION_OPTIONS = [
  {
    value: '1',
    label: 'Alphega Farmacie - Tepes Voda',
  },
  {
    value: '2',
    label: 'Alphega Farmacie - Titulescu',
  },
  {
    value: '3',
    label: 'Chargebee Test Location',
  },
  {
    value: '4',
    label: 'GJ Location',
  },
  {
    value: '5',
    label: 'Greenlight Pharmacy - Bromley-by-Bow',
  },
  {
    value: '6',
    label: 'Greenlight Pharmacy - Cricklewood',
  },
  {
    value: '7',
    label: "Greenlight Pharmacy - Hodgett's Pharmacy",
  },
  {
    value: '8',
    label: 'Greenlight Pharmacy - Keencare Pharmacy Harrow',
  },
  {
    value: '9',
    label: 'Greenlight Pharmacy - Ritchie Street',
  },
  {
    value: '10',
    label: "Greenlight Pharmacy - Shepherd's Bush",
  },
  {
    value: '11',
    label: 'Test',
  },
  {
    value: '12',
    label: 'Test Client Connect 1',
  },
  {
    value: '13',
    label: 'Test Client Connect 2',
  },
  {
    value: '14',
    label: 'Test Site',
  },
  {
    value: '15',
    label: 'Test Time',
  },
];

/** `Dropdown.Select` + `optionLayout="radio"` (Client Connect locations / survey pattern) */
const DROPDOWN_RADIO_LOCATION_OPTIONS = [
  { value: 'loc1', label: 'Montgomery, AL 36116, USA' },
  { value: 'loc2', label: 'Arvada, CO 80007, USA' },
  { value: 'loc3', label: 'Indore, Madhya Pradesh 452002, India' },
];

const ACTION_MENU_MORE_ICON = (
  <span
    aria-hidden
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2,
      width: 18,
      height: 18,
    }}
  >
    {[0, 1, 2].map((i) => (
      <span
        key={i}
        style={{
          width: 3,
          height: 3,
          borderRadius: 999,
          background: 'currentColor',
        }}
      />
    ))}
  </span>
);

/** Figma tile-edit panel (`Dropdown.ActionMenu`) */
const TILE_ACTION_MENU_OPTIONS = [
  { value: 'edit', label: 'Edit tile name', icon: <EditIcon size={16} /> },
  { value: 'resize', label: 'Resize tile', icon: <ExpandAltIcon size={16} /> },
  {
    value: 'dates',
    label: 'Edit date range',
    icon: <DateRangeIcon size={16} />,
  },
  { value: 'lock', label: 'Lock tile', icon: <LockIcon size={16} /> },
  { value: 'ai', label: 'Ask AI', icon: <SparkleIcon size={16} /> },
  { value: 'delete', label: 'Delete tile', icon: <DeleteIcon size={16} /> },
];

const USER_PICKER_OPTIONS_FOR_SEARCH = [
  ...USER_PICKER_OPTIONS,
  {
    value: 'olivia',
    label: 'Olivia Davis',
    subtitle: 'Coordinator',
    avatar: <span aria-hidden>OD</span>,
  },
];

export {
  MULTISELECT_LOCATION_OPTIONS,
  MULTISELECT_FILTER_GROUPS,
  USER_PICKER_OPTIONS,
  LOCATION_OPTIONS,
  DROPDOWN_RADIO_LOCATION_OPTIONS,
  ACTION_MENU_MORE_ICON,
  TILE_ACTION_MENU_OPTIONS,
  USER_PICKER_OPTIONS_FOR_SEARCH,
};
